export default "__VITE_ASSET__Dn$Odf7u__"